module.exports = __webpack_public_path__ + "static/media/ejercicio.be812548.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/ejercicio.png
// module id = 96
// module chunks = 0